<template>
  <b-row class="h-100">
    <b-colxx xxs="12" md="10" class="mx-auto my-auto">
      <b-card class="auth-card" no-body>
        <div class="position-relative image-side">
          <p class="text-white h2">
            Brand Admin Manager
          </p>
        </div>
        <div class="form-side">
          <h6 class="mb-4">{{ $t('user.forgot-id')}}</h6>
          <b-tabs content-class="mt-3" active-nav-item-class=""
                  active-tab-class="font-weight-bold text-success"
                  >
            <b-tab title="이메일로 찾기" @click="resetForm">
              <find-by-email :data="form" @findFunction="findByEmail" _mode ='id' />
            </b-tab>
            <b-tab title="휴대전화 번호로 찾기" @click="resetForm">
              <find-by-phone :data="form" @findFunction="findByPhone" _mode ='id'/>
            </b-tab>
          </b-tabs>
        </div>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";

  import FindByEmail from './components/FindByEmail'
  import FindByPhone from './components/FindByPhoneNumber'
  import api from '../../constants/api'

  export default {
    components : {
      'find-by-email': FindByEmail,
      'find-by-phone': FindByPhone
    },
    data() {
      return {
        form: {
          email : null ,
          fullName : null ,
          phoneNumber : null,
        }
      };
    },
    computed: {
      ...mapGetters(["processing", "resetIdSuccess"])
    },
    methods: {
      ...mapActions(["resetPassword"]),
      findByEmail(){
        console.log(this.form)
      },
      findByPhone(){
        console.log(this.form)
      },
      resetForm(){
        this.form.email = null
        this.form.fullName = null
        this.form.phoneNumber = null
      }
    },
    watch: {
      resetIdSuccess(){

      }
    }
  };
</script>
